export const generateTodayOperationsSheetDRM = (worksheet, todayOps, volumeUnit, t, title) => {
  // Define styles
  const titleStyle = {
    font: { bold: true, size: 14, name: 'Arial' },
    alignment: { horizontal: 'center', vertical: 'middle' }
  };

  const headerStyle = {
    font: { bold: true, name: 'Arial' },
    alignment: { horizontal: 'center', vertical: 'middle', wrapText: true }
  };

  // Add title row
  const titleRow = worksheet.addRow(['', title]);
  titleRow.getCell(2).style = titleStyle;
  worksheet.mergeCells('B1:J1');

  // Add headers
  const headers = [
    t('daily_inventory.headers.last_op_date'),
    'Produit',
    'N° Bacs J',
    'MESURE NIVEAU en mm',
    'Vol. apparent EQUIVALENT EN L',
    'DEGRE apparent',
    'T° apparente',
    'DEGRE CORRIGE à 20°',
    'VOLUME LAV à 20°',
    'VOLUME LAP',
  ];

  const headerRow = worksheet.addRow(headers);
  headerRow.eachCell((cell) => {
    cell.style = headerStyle;
  });

  headerRow.height = 40;

  // Add data rows
  todayOps.forEach(op => {
    // Parse numeric values
    const height = op.form.results.height?.value || op.form.results.height || '';
    const volume = op.form.results.volume?.value || op.form.results.volume || '';
    const measuredTav = op.form.tavInputs.measuredTav?.value || '';
    const temperature = op.form.tavInputs.tavTemperature?.value || '';
    const abvAt20c = op.form.paConversionResults?.abvAt20c?.value || op.form.results.volumeConvResult?.abvAt20c?.value || '';
    const volumeAtTemp = op.form.paConversionResults?.volumeAtTemp?.value || op.form.results.volumeConvResult?.volumeAtTemp?.value || '';
    const pureAlcoholVolume = op.form.paConversionResults?.pureAlcoholVolumeAt20c?.value || op.form.results.volumeConvResult?.pureAlcoholVolumeAt20c?.value || '';

    const row = worksheet.addRow([
      new Date(op.dateAndTime.seconds * 1000 + op.dateAndTime.nanoseconds / 1000000)
        .toLocaleDateString('fr-FR'),
      op.form.extraFields?.find(f => f.name === 'nature-des-produits')?.value || '',
      op.tankName || op.tankNumber,
      height ? parseFloat(height) : '',
      volume ? parseFloat(volume) : '',
      measuredTav ? parseFloat(measuredTav) : '',
      temperature ? parseFloat(temperature) : '',
      abvAt20c ? parseFloat(abvAt20c) : '',
      volumeAtTemp ? parseFloat(volumeAtTemp) : '',
      pureAlcoholVolume ? parseFloat(pureAlcoholVolume) : '',
    ]);

    // Format numeric cells
    [4, 5, 6, 7, 8, 9].forEach(col => {
      const cell = row.getCell(col);
      if (typeof cell.value === 'number') {
        cell.numFmt = '0.00';
      }
    });
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
  ];

  // Set row heights
  worksheet.getRow(1).height = 30; // Title row
  worksheet.getRow(2).height = 30; // Header row
};
